import big5 from './big5.js'
import eng from './eng.js'
let clang = window.localStorage.guanwanglang == 'eng' ? eng : big5
// if(window.localStorage.guanwanglang == undefined){
//     window.localStorage.guanwanglang = "big5"
// }
// console.log(window.localStorage.guanwanglang,"语言log")
export default clang



// WEBPACK FOOTER //
// ./src/assets/language.js